<template>
	<div class="container">
		<div class="main">
			<div class="main-nav">
				<div class="main-nav-list">
					<div class="main-nav-title">
						<span></span>
						<h3>发表</h3>
					</div>
					<ul>
						<li :class="[activePath=='/publicIndex'?'active':'']">
							<router-link to="/publicIndex?type=article">内容发布</router-link>
						</li>
					</ul>
				</div>
				<div class="main-nav-list">
					<div class="main-nav-title">
						<span></span>
						<h3>管理</h3>
					</div>
					<ul>
						<li :class="[activePath=='/publicManage'?'active':'']">
							<router-link to="/publicManage">我的内容</router-link>
						</li>
						<li :class="[activePath=='/userInfo'?'active':'']">
							<router-link to="/userInfo">圈子个人资料</router-link>
						</li>
						<li :class="[activePath=='/pointsDetails'?'active':'']">
							<router-link to="/pointsDetails">积分明细</router-link>
						</li>
					</ul>
				</div>
				<div class="main-nav-list">
					<div class="main-nav-title">
						<span></span>
						<h3>互动</h3>
					</div>
					<ul>
						<li :class="[activePath=='/myCollection'?'active':'']">
							<router-link to="/myCollection">我的收藏</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="content">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'public',
		components: {
			
		},
		data(){
			return {
				activePath: '/publicIndex'
			}
		},
		watch: {
			$route(to, from) {
				let path = to.path
				this.activePath = path
			}
		},
		created(){
			this.activePath = this.$route.fullPath
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.main{
		display: flex;
		max-width: 1200px;
		width: calc(100% - 40px);
		margin: 20px auto;
		padding: 20px;
		.main-nav{
			.main-nav-list{
				margin-bottom: 20px;
				.main-nav-title{
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					h3{
						font-size: 16px;
						font-weight: bold;
					}
					span{
						width: 4px;
						height: 18px;
						margin-right: 4px;
						background: #DD0515;
						border-radius: 2px;
						content: ' ';
						display: block;
					}
				}
			}
			ul{
				padding-top: 2px;
				li{
					width: 138px;
					height: 28px;
					margin-top: 10px;
					margin-right: 30px;
					padding-left: 15px;
					font-size: 16px;
					color: var(--color-text-opacity);
					line-height: 28px;
					box-sizing: border-box;
					border-radius: 6px;
					a{
						display: block;
					}
					a:hover{
						text-decoration: none;
					}
				}
				li.active{
					background:#fff;
					font-weight: bold;
					color: #000;
					font-size: 16px;
					a{
						color: #000
					}
				}
			}
		}
		.content{
			flex: 1;
			padding-left: 20px;
			border-radius: 12px;
			box-sizing: border-box;
			// background: #fff;
			// padding: 20px;
			// overflow: hidden;
			/deep/ .el-tabs__active-bar{
				background-color: #DD0515;
			}
			/deep/ .el-tabs__item.is-active{
				color: #DD0515;
			}
			/deep/ .el-tabs__item:hover{
				color: #DD0515;
			}
		}
	}
</style>
